import posthog from 'posthog-js';

const { VITE_APP_POSTHOG_KEY, VITE_APP_CUSTOMER } = import.meta.env;

// Derived at runtime so the same build distinguishes towertexas vs towersemi.
const customerHostname = window.location.hostname;

let initialized = false;

function canTrack() {
  return Boolean(VITE_APP_POSTHOG_KEY) && VITE_APP_POSTHOG_KEY !== 'null';
}

export function bootstrapPostHog() {
  if (!canTrack() || initialized) {
    return;
  }

  try {
    posthog.init(VITE_APP_POSTHOG_KEY, {
      api_host: 'https://app.posthog.com',
      capture_pageview: true,
      capture_pageleave: true,
      debug: import.meta.env.DEV,
    });
    initialized = true;
  } catch {
    // Ad blocker, network failure, etc. — analytics must never break the app.
  }
}

export function identifyPostHogUser(user) {
  if (!initialized) {
    return;
  }

  posthog.identify(String(user.id), {
    email: user.email,
    name: [user.first_name, user.last_name].filter(Boolean).join(' '),
    customer_hostname: customerHostname,
    customer_name: VITE_APP_CUSTOMER,
  });

  // Group events by hostname — one group = one customer deployment
  posthog.group('customer', customerHostname, {
    hostname: customerHostname,
    customer_name: VITE_APP_CUSTOMER,
  });
}

export function resetPostHog(resetDeviceId = false) {
  if (!initialized) {
    return;
  }

  posthog.reset(resetDeviceId);
}

export { posthog };
